import {ROUTE_CHANGE_COLOR} from "@containers/singleVoyage/voyageTemplates/routeChange/routeChangeStyle";

export const STOP_COLOR_SYNC = {
	line: ROUTE_CHANGE_COLOR.newRoute,
	stop: '#FFFFFF',
	added: ROUTE_CHANGE_COLOR.added,
	changed: ROUTE_CHANGE_COLOR.changed,
	removed: ROUTE_CHANGE_COLOR.removed,
	muted: '#9AA3AE',
}

/** Labels sit on one baseline under the lowest a stop can hang, so they never cross the line. */
const LABEL_TOP = 94

export const sx = {
	// zero intrinsic width: a long line scrolls inside the pane instead of widening the modal
	scroller: {
		width: 0,
		minWidth: '100%',
		overflowX: 'auto',
		overflowY: 'hidden',
		pb: '4px',
		scrollbarWidth: 'thin',
		scrollbarColor: 'rgba(128, 128, 128, 0.4) transparent',
	},
	canvas: {
		position: 'relative',
	},
	circle: {
		position: 'absolute',
		transform: 'translate(-50%, -50%)',
		width: '28px',
		height: '28px',
		boxSizing: 'border-box',
		borderRadius: '50%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		fontSize: '12px',
		fontWeight: 700,
		boxShadow: '0 0 0 2px #fff, 0 1px 3px rgba(0, 0, 0, 0.25)',
		zIndex: 1,
		cursor: 'pointer',
	},
	circleUnchanged: {
		border: `2px solid ${STOP_COLOR_SYNC.line}`,
		boxShadow: '0 0 0 2px #fff',
	},
	circleFolded: {
		bgcolor: 'background.paper',
		color: 'text.secondary',
		border: `1px dashed ${STOP_COLOR_SYNC.muted}`,
		boxShadow: 'none',
		cursor: 'pointer',
		fontSize: '13px',
		'&:hover': {
			borderColor: '#0C6DDF',
			color: '#0C6DDF',
		},
	},
	circleRemoved: {
		bgcolor: 'background.paper',
		color: STOP_COLOR_SYNC.removed,
		border: `1px dashed ${STOP_COLOR_SYNC.removed}`,
		boxShadow: 'none',
	},
	label: {
		position: 'absolute',
		top: `${LABEL_TOP}px`,
		transform: 'translateX(-50%)',
		width: '72px',
		textAlign: 'center',
		fontSize: '11px',
		lineHeight: 1.25,
		color: 'text.primary',
		display: '-webkit-box',
		WebkitLineClamp: 2,
		WebkitBoxOrient: 'vertical',
		overflow: 'hidden',
		wordBreak: 'break-word',
	},
	labelFolded: {
		color: 'text.secondary',
		fontStyle: 'italic',
		cursor: 'pointer',
	},
	labelRemoved: {
		color: 'text.secondary',
		textDecoration: 'line-through',
	},
	was: {
		position: 'absolute',
		transform: 'translateX(-50%)',
		fontSize: '10px',
		color: 'text.secondary',
		whiteSpace: 'nowrap',
	},
	collapse: {
		position: 'absolute',
		transform: 'translateX(-50%)',
		px: '6px',
		fontSize: '11px',
		color: '#0C6DDF',
		bgcolor: 'background.paper',
		cursor: 'pointer',
		whiteSpace: 'nowrap',
		'&:hover': {
			textDecoration: 'underline',
		},
	},
	changes: {
		gap: '2px',
	},
	changeLine: {
		fontSize: '12px',
		color: 'text.secondary',
		display: 'flex',
		flexWrap: 'wrap',
		gap: '2px 12px',
	},
	changeNumber: {
		fontWeight: 700,
		color: 'text.primary',
	},
	changePart: {
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		maxWidth: '100%',
	},
	before: {
		textDecoration: 'line-through',
	},
	after: {
		color: 'text.primary',
		fontWeight: 600,
	},
}
